import React, { Component } from 'react';
import { Bar, Line, Pie, Doughnut, Polar } from 'react-chartjs-2';
import config from "react-global-configuration";
import { AESEncryption, AESDecryption } from '../utils/AesUtil';
import NumberFormat from 'react-number-format';
import { CommonGet } from '../utils/CommonFetch';
import { GetUserBranch, GetUserName } from '../utils/GetUser';
import tokenDecoder from '../../src/components/Common/tokenDecoder';
import { colorGenerator } from '../../src/components/Modules/Common/Utils/colorGenarator';
import { array } from '@hapi/joi';
import { da } from 'date-fns/locale';
import index from 'react-to-pdf';
import { dateTime } from '../components/Common/dateTime'

var serviceUrl = config.get('apidomain');
var identityUrl = config.get('identityDomain');
var identityClientID = config.get('identityClientID');

export class Home extends Component {

    displayName = Home.name
    state = {
        operationEntityID: tokenDecoder.getoperationEntityFromToken(),
        dailyActiveUsers: 0,
        monthlyActiveUsers: 0,
        activeRoutes: 0,
        activeSessions: 0,
        dailyCollectionNetAmount: 0,
        monthlyCollectionNetAmount: 0,
        masterCardCustomerCountDaily: 0,
        masterCardCustomerCountMonthly: 0,
        masterCardTotalAmountDaily: 0,
        masterCardTotalAmountMonthly: 0,
        dateTimeVal: "",
        Data: {
            labels: [],
            datasets: [],
        },
        lineChartData: {
            labels: [],
            datasets: [],
        },
        dougnutChartData: {
            labels: [],
            datasets: [],
        },
        collectionCategoryBarChartData: {
            labels: [],
            datasets: [],
        },
        collectionCategoryLineChartData: {
            labels: [],
            datasets: [],
        },
        collectionCategoryLineChartMonthly: {
            labels: [],
            datasets: [],
        },
        options: {
            cutoutPercentage: 75
        },
        collectionCategoryYearlyLineChartData: {
            labels: [],
            datasets: [],
        },
    };

    componentDidMount() {

        this.setState({
            dateTimeVal: dateTime()
        });

        CommonGet('/api/Dashboard/GetDashBoardData', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {
                this.setState({
                    dailyActiveUsers: data.data.dailyCustomerCount === null ? 0 : data.data.dailyCustomerCount,
                    monthlyActiveUsers: data.data.monthlyCustomerCount === null ? 0 : data.data.monthlyCustomerCount,
                    activeRoutes: data.data.activeRoutes === null ? 0 : data.data.activeRoutes,
                    activeSessions: data.data.activeSessions === null ? 0 : data.data.activeSessions,
                    dailyCollectionNetAmount: data.data.dailyTotalAmount === null ? 0 : data.data.dailyTotalAmount,
                    monthlyCollectionNetAmount: data.data.monthlyTotalAmount === null ? 0 : data.data.monthlyTotalAmount,
                    masterCardCustomerCountDaily: data.data.customerCountDailyMasterCard === null ? 0 : data.data.customerCountDailyMasterCard,
                    masterCardCustomerCountMonthly: data.data.customerCountMonthlyMasterCard === null ? 0 : data.data.customerCountMonthlyMasterCard,
                    masterCardTotalAmountDaily: data.data.totalAmountDailyMasterCard === null ? 0 : data.data.totalAmountDailyMasterCard,
                    masterCardTotalAmountMonthly: data.data.totalAmountMonthlyMasterCard === null ? 0 : data.data.totalAmountMonthlyMasterCard,
                });
            });

        CommonGet('/api/Dashboard/GetCollectionCategoryDataOfMonth', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                var collectionCategoryLable = [];
                var collectionCategoryData = [];

                for (let item of Object.entries(data.data)) {
                    collectionCategoryLable.push(item[1]["collectionTypeName"]);
                    collectionCategoryData.push(item[1]["totalAmount"]);
                }

                this.setState({
                    dougnutChartData: {
                        datasets: [{
                            label: 'Collection Types',
                            data: collectionCategoryData,
                            backgroundColor: colorGenerator(collectionCategoryLable.length)
                        }],
                        labels: collectionCategoryLable,
                    },
                    collectionCategoryBarChartData: {
                        labels: collectionCategoryLable,
                        datasets: [{
                            data: collectionCategoryData,
                            label: "Collection Category",
                            backgroundColor: colorGenerator(collectionCategoryLable.length),
                        }]
                    }
                });
            });

        CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountByDay', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                let daysArray = [];

                data.data.forEach(e => {
                    daysArray.push(e.daysOfMonth);
                });

                daysArray = [... new Set(daysArray)];

                let groupedResult = data.data.reduce(function (acc, obj) {
                    let key = obj['collectionTypeMasterID']
                    if (!acc[key]) {
                        acc[key] = []
                    }
                    acc[key].push(obj)
                    return acc
                }, {});

                let keys = Object.keys(groupedResult);

                let dynamicDataSet = [];
                let dynamicDays = [];

                keys.forEach(x => {

                    let daysCount = new Array(daysArray.length);

                    let res = {
                        label: groupedResult[x][0]["collectionTypeName"],
                        borderColor: colorGenerator(1),
                        fill: false,
                        pointRadius: 5,
                        data: []
                    }

                    groupedResult[x].forEach(e => {
                        daysArray.forEach((a, index) => {
                            if (a === e.daysOfMonth) {
                                daysCount[index] = e.totalAmount;
                            }
                        })
                    });

                    res.data = daysCount;
                    dynamicDataSet.push(res);
                });

                this.setState({
                    collectionCategoryLineChartData: {
                        labels: daysArray,
                        datasets: dynamicDataSet
                    }
                });
            });

        CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountMonthly', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                let dynamicDataSet = [];
                let monthsArrray = [];

                data.data.forEach(x => monthsArrray.push(x.monthName));

                monthsArrray = [...new Set(monthsArrray)];

                let groupedResult = data.data.reduce(function (acc, obj) {
                    let key = obj['collectionTypeMasterID']
                    if (!acc[key]) {
                        acc[key] = []
                    }
                    acc[key].push(obj)
                    return acc
                }, {})

                let keys = Object.keys(groupedResult);

                keys.forEach(x => {

                    //Check Again
                    let valueArray = [, , , , , , , , , , ,]
                    let res = {
                        label: groupedResult[x][0]["collectionTypeName"],
                        borderColor: colorGenerator(1),
                        fill: false,
                        pointRadius: 5,
                        data: []
                    }

                    groupedResult[x].forEach(e => {
                        monthsArrray.forEach((m, index) => {
                            if (m === e.monthName) {
                                valueArray[index] = e.totalAmount
                            }
                        });
                    });

                    res.data = valueArray;
                    dynamicDataSet.push(res);
                });

                this.setState({
                    collectionCategoryLineChartMonthly: {
                        labels: monthsArrray,
                        datasets: dynamicDataSet
                    }
                });
            });

        CommonGet('/api/Dashboard/GetCollectionsGroupByMonth', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                var amountArray = [];
                var actualAmountArray = [];
                var grossAmountArray = [];
                var monthArray = [];

                for (let item of Object.entries(data.data)) {
                    amountArray.push(item[1]["totalAmount"]);
                    monthArray.push(item[1]["monthName"]);
                    grossAmountArray.push(item[1]["grossAmount"]);
                    actualAmountArray.push(item[1]["actualAmount"]);
                }

                this.setState({
                    Data: {
                        labels: monthArray,
                        datasets: [
                            {
                                label: "Total Amount",
                                data: amountArray,
                                backgroundColor: "#45c490"
                            },
                            {
                                label: "Gross Amount",
                                data: grossAmountArray,
                                backgroundColor: "#008d93"
                            },
                            {
                                label: "Actual Amount",
                                data: actualAmountArray,
                                backgroundColor: "#2e5468"
                            }
                        ]
                    }
                });
            });

        CommonGet('/api/Dashboard/GetCollectionGroupByDay', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                var amountArray = [];
                var actualAmountArray = [];
                var grossAmountArray = [];
                var daysArray = [];

                for (let item of Object.entries(data.data)) {
                    amountArray.push(item[1]["totalAmount"]);
                    daysArray.push(item[1]["daysOfMonth"]);
                    grossAmountArray.push(item[1]["grossAmount"]);
                    actualAmountArray.push(item[1]["actualAmount"]);
                }

                this.setState({
                    lineChartData: {
                        labels: daysArray,
                        datasets: [
                            {
                                label: "Total Amount",
                                data: amountArray,
                                borderColor: "#45c490"
                            },
                            {
                                label: "Gross Amount",
                                data: grossAmountArray,
                                borderColor: "#008d93"
                            },
                            {
                                label: "Actual Amount",
                                data: actualAmountArray,
                                borderColor: "#2e5468"
                            }
                        ]
                    }
                });

            });

        CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountByMonthlyThisYearPreviousYear', "operationEntityID=" + parseInt(this.state.operationEntityID))
            .then(data => {

                var collectionTypeArray = [];
                var thisYearMap = new Map();
                var previousYearMap = new Map();
                var thisYearData = [];
                var previousYearData = [];

                for (let item of Object.entries(data.data.previousYear)) {
                    collectionTypeArray.push(item[1].collectionTypeName);
                    previousYearMap.set(item[1].collectionTypeName, item[1].totalAmount);
                }

                for (let item of Object.entries(data.data.thisYear)) {
                    collectionTypeArray.push(item[1].collectionTypeName);
                    thisYearMap.set(item[1].collectionTypeName, item[1].totalAmount);
                }

                var sortedCollectionTypes = [... new Set(collectionTypeArray)]; 

                sortedCollectionTypes.forEach(ct => {
                    thisYearData.push(thisYearMap.get(ct));
                    previousYearData.push(previousYearMap.get(ct));
                });

                this.setState({
                    collectionCategoryYearlyLineChartData: {
                        labels:  sortedCollectionTypes,
                        datasets: [
                            {
                                label: new Date().getFullYear()-1,
                                data: previousYearData,
                                backgroundColor: "#45c490"
                            },
                            {
                                label: new Date().getFullYear(),
                                data: thisYearData,
                                backgroundColor: "#008d93"
                            }
                        ]
                    }
                });

            });
    }

    componentWillMount() {
        var codes = sessionStorage.getItem('oidc.user:' + identityUrl + ':' + identityClientID);
        var convert = JSON.parse(codes);

        const queryStringdashboard = 'username=' + convert.profile.name;
        const encryptedQueryStringdashboard = AESEncryption(queryStringdashboard);
    }

    render() {
        return (
            <div>
                <div class="card scard-1">
                    <div className="row">
                        <div className="col">
                            <h4 class="card-text pl-2 float-left hometextcolor">DashBoard</h4>
                        </div>
                        <div className="col">
                            <h4 class="card-text pr-2 float-right hometextcolor">{this.state.dateTimeVal}</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative card-1">
                            <div className="card-body">
                                <div className="mini-stat-desc">
                                    <h5 className="mt-0 pb-2 card-title cardtext-1">Active customers</h5>
                                    <div className="pb-2">
                                        <h5 className="d-inline text-capitalize cardtext-1">Daily : </h5> <h5 className="d-inline cardtext-1">{this.state.dailyActiveUsers}</h5>
                                    </div>
                                    <div>
                                        <h5 className="d-inline text-capitalize cardtext-1">Monthly : </h5> <h5 className="d-inline cardtext-1">{this.state.monthlyActiveUsers}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative card-1">
                            <div className="card-body">
                                <div className="mini-stat-desc">
                                    <h5 className="cardtext-2 mt-0 pb-2">Collection</h5>
                                    <div className="pb-2">
                                        <h5 className="d-inline text-capitalize cardtext-2">Daily : </h5> <h5 className="d-inline cardtext-2"><NumberFormat value={this.state.dailyCollectionNetAmount} displayType={'text'} thousandSeparator={true} prefix={''} decimalSeparator={'.'} decimalScale={2} fixedDecimalScale={true} /></h5>
                                    </div>
                                    <div>
                                        <h5 className="d-inline text-capitalize cardtext-2">Monthly : </h5> <h5 className="d-inline cardtext-2"><NumberFormat value={this.state.monthlyCollectionNetAmount} displayType={'text'} thousandSeparator={true} prefix={''} decimalSeparator={'.'} decimalScale={2} fixedDecimalScale={true} /></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card shadow-lg position-relative card-1">
                            <div className="card-body">
                                <div className="mini-stat-desc">
                                    <h5 className="mt-0 pb-2 cardtext-3">Active</h5>
                                    <div className="pb-2">
                                        <h5 className="d-inline text-capitalize cardtext-3">Sessions : </h5> <h5 className="d-inline cardtext-3"> {this.state.activeSessions} </h5>
                                    </div>
                                    <div>
                                        <h5 className="d-inline text-capitalize cardtext-3">Routes : </h5> <h5 className="d-inline cardtext-3"> {this.state.activeRoutes} </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative card-1">
                            <div className="card-body">
                                <div className="mini-stat-desc">
                                    <h5 className="mt-0 pb-2 cardtext-4">Master Card</h5>
                                    <div className="row no-gutters">
                                        <div className="col-sm">Daily</div>
                                        <div className="col-sm">Monthly</div>
                                    </div>
                                    <div className="row no-gutters pb-2">
                                        <div className="col">
                                            <h6 className="d-inline text-capitalize cardtext-4">Customers : </h6> <h5 className="d-inline cardtext-4"> {this.state.masterCardCustomerCountDaily} </h5>
                                        </div>
                                        <div className="col">
                                            <h6 className="d-inline text-capitalize cardtext-4">Customers : </h6> <h5 className="d-inline cardtext-4"> {this.state.masterCardCustomerCountMonthly} </h5>
                                        </div>
                                    </div>
                                    <div className="row no-gutters">
                                        <div className="col padding-0">
                                            <h6 className="d-inline text-capitalize cardtext-4">Collection : </h6> <h5 className="d-inline cardtext-4"> {this.state.masterCardTotalAmountDaily} </h5>
                                        </div>
                                        <div className="col">
                                            <h6 className="d-inline text-capitalize cardtext-4">Collection : </h6> <h5 className="d-inline cardtext-4"> {this.state.masterCardTotalAmountMonthly} </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pt-2">
                    <div class="row">
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection Category By Month</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" box">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Doughnut
                                                    height="300px"
                                                    data={this.state.dougnutChartData}
                                                    options={{
                                                        responsive: true,
                                                        maintainAspectRatio: true
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Bar
                                                    height="300px"
                                                    data={this.state.collectionCategoryBarChartData}
                                                    options={{
                                                        responsive: true,
                                                        scales: {
                                                            xAxes: [{ stacked: true }],
                                                            yAxes: [{ stacked: true }]
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection Category By Day</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" box">
                                        <div className="row">
                                            <Line
                                                data={this.state.collectionCategoryLineChartData}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection by day</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" box">
                                        <div className="row">
                                            <Line
                                                data={this.state.lineChartData}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection by month</h4>
                                </div>
                                <div className="card-body">
                                    <Bar
                                        data={this.state.Data}
                                        options={{
                                            responsive: true,
                                            scales: {
                                                xAxes: [{ stacked: true }],
                                                yAxes: [{ stacked: true }]
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection Category Monthly Amount</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" box">
                                        <div className="row">
                                            <Line
                                                data={this.state.collectionCategoryLineChartMonthly}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 pb-4">
                            <div className="card ccard-1 h-100">
                                <div className="card-header">
                                    <h4 className="hometextcolor">Collection by month This year and previous year</h4>
                                </div>
                                <div className="card-body">
                                    <Bar
                                        data={this.state.collectionCategoryYearlyLineChartData}
                                        options={{
                                            responsive: true,
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        min: 0,
                                                    }
                                                }]
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
